import React from "react";
import { MdClose } from "react-icons/md";
import { Link as DomLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import MainDrawer from "./MainDrawer";
import { HeaderMenuLinks, SocialIconsData } from "../../constants/data";
import { zivaLogoWhiteBg_Image, zivaLogo_Image } from "../../constants/imageConstants";

function MenuDrawer({ drawerOpen, toggleDrawer }) {

  return (
    <MainDrawer drawerOpen={drawerOpen} closeDrawer={toggleDrawer}>
      <div className="flex flex-col w-full  h-auto justify-between items-center  text-white rounded">
        <div className="w-full flex-btn h-14 px-2 py-8  justify-between border-b flex items-center ">
          <ScrollLink onClick={toggleDrawer} to="/" spy={true} smooth={true} offset={-80} duration={500}>
            <img
              loading="lazy"
              src={zivaLogo_Image}
              alt="logo"
              className="w-full h-14 rounded-md object-cover"
            />
          </ScrollLink>
          <button
            aria-label="md-close"
            onClick={toggleDrawer}
            type="button"
            className="
                transitions w-8 h-8 flex-colo text-base font-medium text-black bg-white rounded-md hover:bg-main hover:text-white"
          >
            <MdClose size={20} />
          </button>
        </div>
        {/* menu links */}
        <div className="w-full overflow-y-auto h-auto flex-grow max-height-full">
          <div className="pt-4 p-2">
            {HeaderMenuLinks.map((link, index) => (
              <ScrollLink
                to={`${link.path}`}
                onClick={toggleDrawer}
                spy={true} smooth={true} offset={-120} duration={500}
                key={index}
                className="flex flex-row gap-4 items-center text-gray-500 p-4 hover:bg-main hover:text-white cursor-pointer transitions hover:rounded-sm rounded-sm"
              >
                <link.icon className="text-2xl " aria-label={link.name} />
                <button aria-label={link.name} className="text-lg">{link.name}</button>
              </ScrollLink>
            ))}
          </div>

          <div className="pt-10 flex gap-4 flex-col pb-10">
            <div className="bg-white border">
              <p className="text-lg pl-5 py-4 text-main uppercase">Contact Us</p>
            </div>
            <div className="flex flex-col text-black mx-5 mb-2">
              <span>(+91) 9989785556 / (+91) 9704456746</span>
              <span>contactus@zivainteriors.com</span>
              <span>Ziva Interiors | Masab Tank, Hyderabad India 500088</span>
            </div>
            <div className="flex flex-wrap flex-row items-center justify-between gap-6 w-full pl-5">
              <div className="flex flex-wrap flex-row items-center gap-5">
                {SocialIconsData.map((item, index) => (
                  <DomLink
                    key={index}
                    to={item.path}
                    className="flex flex-rows gap-2 
                  text-black text-sm hover:text-water transitions
                  bg-white shadow p-4 rounded-md hover:bg-main hover:text-white
                  "
                  >
                    <item.icon />
                  </DomLink>
                ))}
              </div>
            </div>
            <div className="flex justify-center items-center ">
              <p className="text-black ">© 2023 Ziva Interiors.</p>
            </div>
          </div>
        </div>
      </div>
    </MainDrawer>
  );
}

export default MenuDrawer;
